import { useSyncExternalStore } from "react";
import authSession from "../services/authSession";

export const useAuth = () => {
  const snapshot = useSyncExternalStore(authSession.subscribe, authSession.getSnapshot);
  return { ...snapshot, login: authSession.startSession, logout: authSession.endSession };
};
